import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import CoreComponent from "./CoreComponent";
import { IProducer, IHolder } from "../interfaces";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import ProducerModal from "../components/ProducerModal";
import { toast } from "react-toastify";
import { arrayToFormData } from "../utils/functions";
import ProducersHolderModal from "../components/ProducersHolderModal";

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    producers: IProducer[];
    holders: IHolder[];
    limit: number;
    ids: number[];
    type: string;
    holderType: string;
    sort: string;
    holderSort: string;
    isLoading: boolean;
    isHoldersLoading: boolean;
    selected_producer: number;
    isOpen: boolean;
    isHolderOpen: boolean;
    producers_ids: number[];
    holders_ids: number[];
}

class Producers extends CoreComponent<any, IState> {
    state: IState = {
        producers: [],
        holders: [],
        limit: 30,
        ids: [],
        type: "",
        sort: "",
        holderType: "",
        holderSort: "",
        isLoading: true,
        isHoldersLoading: false,
        selected_producer: null,
        isOpen: false,
        isHolderOpen: false,
        producers_ids: [],
        holders_ids: [],
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
        this.handleHolderModal = this.handleHolderModal.bind(this);
    }

    async componentWillMount() {
        this.loadProducers();
    }

    async loadProducers(search: string = null) {
        cancel && cancel();

        this.setState(
            {
                isLoading: true,
                producers: [],
                selected_producer: null,
                holders: [],
                producers_ids: [],
            },
            async () => {
                let url = null;

                url = `${config.api}/producer?limit=${this.state.limit}`;

                if (this.state.sort) {
                    url += `&sort=${this.state.sort}`;
                }

                if (this.state.type) {
                    url += `&type=${this.state.type}`;
                }

                if (search) {
                    url += `&search=${search}`;
                }

                let res = await Axios.get(url, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                if (!this.isUnmounted && res) {
                    this.setState({
                        producers: res.data.models,
                        isLoading: false,
                    });
                }
            }
        );
    }

    async loadHolders() {
        if (this.state.selected_producer) {
            this.setState(
                {
                    holders: [],
                    isHoldersLoading: true,
                },
                async () => {
                    let url = null;

                    url = `${config.api}/producer/holders?producer_id=${this.state.selected_producer}`;

                    if (this.state.holderSort) {
                        url += `?sort=${this.state.holderSort}`;
                    }

                    if (this.state.holderType) {
                        url += `&type=${this.state.holderType}`;
                    }

                    let res = await Axios.get(url);

                    if (!this.isUnmounted) {
                        this.setState({
                            holders: res.data.models,
                            isHoldersLoading: false,
                        });
                    }
                }
            );
        }
    }

    setOrder(sort: string) {
        this.setState(
            {
                type:
                    this.state.sort != sort
                        ? "asc"
                        : this.state.type == "asc"
                            ? "desc"
                            : "asc",
                sort,
            },
            () => {
                this.loadProducers();
            }
        );
    }

    setHolderOrder(sort: string) {
        this.setState(
            {
                holderType:
                    this.state.holderSort != sort
                        ? "asc"
                        : this.state.holderType == "asc"
                            ? "desc"
                            : "asc",
                holderSort: sort,
            },
            () => {
                this.loadHolders();
            }
        );
    }

    handleModal() {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                this.loadProducers();
            }
        );
    }

    handleHolderModal() {
        if (this.state.selected_producer) {
            this.setState(
                {
                    isHolderOpen: !this.state.isHolderOpen,
                },
                () => {
                    this.loadHolders();
                }
            );
        } else {
            toast("Выберите продюсера", { type: "error" });
        }
    }

    async deleteProducers() {
        if (confirm("Вы уверены?")) {
            if (this.state.producers_ids.length > 0) {
                let response: AxiosResponse = await Axios.post(
                    `${config.api}/producer/delete`,
                    arrayToFormData({ ids: this.state.producers_ids })
                );

                if (response.data && response.data.length > 0)
                    this.setState({
                        producers: this.state.producers.filter(
                            (producer: IProducer) =>
                                !response.data.includes(producer.id.toString())
                        ),
                        producers_ids: [],
                    });

                toast("Продюсеры удалены: " + response.data.length, {
                    type: "success",
                });
            } else {
                toast("Выберите продюсеров", { type: "error" });
            }
        }
    }

    async deleteHolders() {
        if (confirm("Вы уверены?")) {
            if (this.state.holders_ids.length > 0) {
                let response: AxiosResponse = await Axios.post(
                    `${config.api}/producer/delete-holders`,
                    arrayToFormData({
                        ids: this.state.holders_ids,
                        producer_id: this.state.selected_producer,
                    })
                );

                if (response.data && response.data.length > 0)
                    this.setState({
                        holders: this.state.holders.filter(
                            (holder: IHolder) =>
                                !response.data.includes(holder.id.toString())
                        ),
                        holders_ids: [],
                    });

                toast("Правообладатели удалены: " + response.data.length, {
                    type: "success",
                });
            } else {
                toast("Выберите правообладателей", { type: "error" });
            }
        }
    }

    componentWillReceiveProps(nextProps: any) {
        let { search } = nextProps;

        this.loadProducers(search);
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders producers">
                <ProducerModal
                    isOpen={this.state.isOpen}
                    handleModal={this.handleModal}
                />
                <ProducersHolderModal
                    isOpen={this.state.isHolderOpen}
                    handleModal={this.handleHolderModal}
                    producer_id={this.state.selected_producer}
                />
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">Продюсеры</span>
                    <div className="crm-holders__headline">
                        <div className="crm-holders__buttons">
                            <a
                                className="crm-button"
                                role="button"
                                onClick={() => {
                                    this.handleModal();
                                }}
                            >
                                Добавить
                            </a>
                            <a
                                className="crm-button"
                                role="button"
                                onClick={() => {
                                    this.deleteProducers();
                                }}
                            >
                                Удалить
                            </a>
                        </div>
                        {/* <div className="crm-holders__count">
                            <img src="img/Group 205.svg" alt="" />
                            <select
                                id="select_page"
                                style={{ width: "70px" }}
                                className="numm"
                                value={this.state.limit}
                                onChange={(e: any) => {
                                    this.setState({
                                        limit: Number.parseInt(e.target.value)
                                    }, () => {
                                        this.loadProducers();
                                    });
                                }}
                            >
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                                <option value="100000">Все</option>
                            </select>
                            <img className="crm-img" src="img/crm-arrow.svg" alt="" /> 
                        </div>*/}
                    </div>
                    <div className="crm-tables">
                        <div
                            style={{
                                display: "flex",
                                width: "100%",
                                flexWrap: "wrap",
                            }}
                        >
                            <div className="crm-table crm-list">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    onChange={() => {
                                                        if (
                                                            this.state.producers_ids
                                                                .length !=
                                                            this.state.producers
                                                                .length
                                                        ) {
                                                            this.setState({
                                                                producers_ids: this.state.producers.map(
                                                                    (
                                                                        producer: IProducer
                                                                    ) => producer.id
                                                                ),
                                                            });
                                                        } else {
                                                            this.setState({
                                                                producers_ids: [],
                                                            });
                                                        }
                                                    }}
                                                    checked={
                                                        this.state.producers_ids
                                                            .length ==
                                                        this.state.producers.length
                                                    }
                                                />
                                            </th>
                                            <th>
                                                <a
                                                    role="button"
                                                    onClick={() => {
                                                        this.setOrder("id");
                                                    }}
                                                >
                                                    ID
                                            </a>
                                            </th>
                                            <th>
                                                <a
                                                    role="button"
                                                    onClick={() => {
                                                        this.setOrder("name");
                                                    }}
                                                >
                                                    Продюсер{" "}
                                                    <img
                                                        src="img/Group 199.svg"
                                                        alt=""
                                                    />
                                                </a>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {!this.state.isLoading && this.state.producers.length == 0 && <tr>
                                            <td colSpan={3}>Ничего не найдено</td>
                                        </tr>}
                                        {this.state.producers.map(
                                            (producer: IProducer, i: number) => {
                                                return (
                                                    <tr
                                                        key={i}
                                                        onClick={() => {
                                                            this.setState(
                                                                {
                                                                    selected_producer:
                                                                        producer.id,
                                                                },
                                                                () => {
                                                                    this.loadHolders();
                                                                }
                                                            );
                                                        }}
                                                        className={
                                                            producer.id ==
                                                                this.state
                                                                    .selected_producer
                                                                ? "active"
                                                                : ""
                                                        }
                                                    >
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    !!this.state.producers_ids.find(
                                                                        (
                                                                            id: number
                                                                        ) =>
                                                                            id ==
                                                                            producer.id
                                                                    )
                                                                }
                                                                onChange={(
                                                                    e: any
                                                                ) => {
                                                                    if (
                                                                        e.target
                                                                            .checked
                                                                    ) {
                                                                        this.setState(
                                                                            {
                                                                                producers_ids: [
                                                                                    ...this
                                                                                        .state
                                                                                        .producers_ids,
                                                                                    producer.id,
                                                                                ],
                                                                            }
                                                                        );
                                                                    } else {
                                                                        this.setState(
                                                                            {
                                                                                producers_ids: this.state.producers_ids.filter(
                                                                                    (
                                                                                        id: number
                                                                                    ) =>
                                                                                        id !=
                                                                                        producer.id
                                                                                ),
                                                                            }
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                        </td>
                                                        <td>{producer.id}</td>
                                                        <td>
                                                            <a role="button">
                                                                {producer.full_name}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>


                                </table>
                            </div>
                            <div className="crm-table crm-list">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    onChange={() => {
                                                        if (
                                                            this.state.holders_ids
                                                                .length !=
                                                            this.state.holders
                                                                .length
                                                        ) {
                                                            this.setState({
                                                                holders_ids: this.state.holders.map(
                                                                    (
                                                                        producer: IProducer
                                                                    ) => producer.id
                                                                ),
                                                            });
                                                        } else {
                                                            this.setState({
                                                                holders_ids: [],
                                                            });
                                                        }
                                                    }}
                                                    checked={
                                                        this.state.holders_ids
                                                            .length ==
                                                        this.state.holders.length
                                                    }
                                                />
                                            </th>
                                            <th>
                                                <a
                                                    role="button"
                                                    onClick={() => {
                                                        this.setHolderOrder("id");
                                                    }}
                                                >
                                                    ID
                                            </a>
                                            </th>
                                            <th>
                                                <a
                                                    role="button"
                                                    onClick={() => {
                                                        this.setHolderOrder("name");
                                                    }}
                                                >
                                                    Правообдадтели{" "}
                                                    <img
                                                        src="img/Group 199.svg"
                                                        alt=""
                                                    />
                                                </a>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {!this.state.selected_producer && (
                                            <tr>
                                                <td colSpan={3}>
                                                    Выберите продюсера
                                            </td>
                                            </tr>
                                        )}
                                        {this.state.selected_producer &&
                                            this.state.holders.length == 0 &&
                                            !this.state.isHoldersLoading && (
                                                <tr>
                                                    <td colSpan={3}>Пусто</td>
                                                </tr>
                                            )}
                                        {this.state.holders.map(
                                            (holder: IHolder, i: number) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    !!this.state.holders_ids.find(
                                                                        (
                                                                            id: number
                                                                        ) =>
                                                                            id ==
                                                                            holder.id
                                                                    )
                                                                }
                                                                onChange={(
                                                                    e: any
                                                                ) => {
                                                                    if (
                                                                        e.target
                                                                            .checked
                                                                    ) {
                                                                        this.setState(
                                                                            {
                                                                                holders_ids: [
                                                                                    ...this
                                                                                        .state
                                                                                        .holders_ids,
                                                                                    holder.id,
                                                                                ],
                                                                            }
                                                                        );
                                                                    } else {
                                                                        this.setState(
                                                                            {
                                                                                holders_ids: this.state.holders_ids.filter(
                                                                                    (
                                                                                        id: number
                                                                                    ) =>
                                                                                        id !=
                                                                                        holder.id
                                                                                ),
                                                                            }
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                        </td>
                                                        <td>{holder.id}</td>
                                                        <td>
                                                            <a role="button">
                                                                {holder.full_name}
                                                            </a>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>


                                </table>
                            </div>
                        </div>
                        <div className="btns">
                            <a
                                className="btn-add"
                                role="button"
                                onClick={() => {
                                    this.handleHolderModal();
                                }}
                            >
                                Добавить
                            </a>
                            <a
                                className="btn-del"
                                role="button"
                                onClick={() => {
                                    this.deleteHolders();
                                }}
                            >
                                Удалить
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
        search: state.search
    };
})(withTranslation()(Producers));
